import { Alert, Button } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { If } from "lib/@components/switch"
import { isEnabled } from "lib/@components/feature"
import { refreshId } from "lib/graphql/api"
import { getMappingFreshness } from "routes/asset-register/plugins/asset-mapping/controller/get-mapping-freshness"
import { isMappingStale } from "routes/asset-register/plugins/asset-mapping/mapping-freshness.mjs"
import { FEATURE_FLAG_REFRESH_ALL_MAPPINGS } from "routes/asset-register/plugins/asset-mapping/feature-flag-refresh-all-mappings.runtime"
import { OpenMappingSettings } from "routes/asset-register/plugins/asset-mapping/settings-dialog"

/**
 * FIQ-1554: tells the user their asset data changed since mapping last ran.
 * Purely informational - it never starts a mapping run itself. The action button
 * opens the Mapping Settings dialog, where Apply Settings is the standard trigger;
 * accounts with the Refresh All Mappings flag also see that button mentioned.
 */
export function DataChangedBanner() {
    const { target, isManualMapTab } = useBoundContext()
    const freshness = getMappingFreshness.useResults(refreshId(target?._id))
    const stale = !isManualMapTab && isMappingStale(freshness)
    const remapHint = isEnabled(FEATURE_FLAG_REFRESH_ALL_MAPPINGS)
        ? 'Re-run mapping with "Apply Settings" or the "Refresh All Mappings" button when you are ready.'
        : 'Re-run mapping with "Apply Settings" when you are ready.'

    return (
        <If truthy={stale}>
            <Alert
                severity="info"
                data-cy="mapping-data-changed-banner"
                action={
                    <Button
                        color="inherit"
                        size="small"
                        onClick={openSettings}
                        data-cy="mapping-data-changed-banner-settings"
                    >
                        Open Settings
                    </Button>
                }
            >
                Your asset data has changed since mapping last ran, so some results may be out of date. {remapHint}
            </Alert>
        </If>
    )

    function openSettings() {
        OpenMappingSettings.raise()
    }
}
